/** 
 * @file /src/components/demo/relationships/RelationshipsGraphDialog.js
 * @description Modal dialog that contains the relationship graph
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import Legend from '../Legend';
import RelationshipsGraph from './RelationshipsGraph';

/**
 * @class
 * @description Modal dialog that contains the relationship graph
 * @property relationships - Array of relationship objects
 */
class RelationshipsGraphDialog extends Component {

    /** @constructor */
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);

        this.state = {
            error: '',
            modalOpen: false
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_RelationshipsGraphDialog');
    }

    /**
     * Close the dialog box
     */
    close() {
        this.setState({
            modalOpen: false
        })
    };

    /**
     * Open the dialog box
     */
    open() {
        this.setState({
            modalOpen: true
        })
    };

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '90%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <span id="rm_RelationshipsGraphDialog">
                <button className="link-button" onClick={this.open}>
                    <span className='fa fa-share-alt'></span>{this.props.iconOnly ? '' : ' Relationships'}
                </button>
                <ReactModal ref="relationshipsId" 
                    isOpen={this.state.modalOpen}
                    contentLabel="Relationships"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={250}>
                    <div className="relationships-dialog">
                        <div className="relationships-header">
                            Relationships
                        </div>
                        <div className="relationships-description">
                            <span className='fa fa-share-alt relationships-icon'>&nbsp;</span>
                            Graph view of relationships extracted from text.    
                        </div>
                        <div className="relationships-content">
                            <div className="relationships-form">
                                <RelationshipsGraph entitiesData={this.props.entitiesData} relationships={this.props.relationships}/>
                                <br/>
                                <span className="relationships-error-msg">{this.state.error}</span>
                            </div>
                        </div>
                        <div className="relationships-footer">
                            <span className="relationships-legend">
                                <Legend types={[
                                    {selected: true, name: 'PERSON'}, 
                                    {selected: true, name: 'ORGANIZATION'},
                                    {selected: true, name: 'GEO'},
                                    {selected: true, name: 'QUOTE'},
                                    {selected: true, name: 'TWITTER'},
                                    {selected: true, name: 'EMAIL'},
                                    {selected: true, name: 'PHONE'},
                                    {selected: true, name: 'NATIONALITY'},
                                    {selected: true, name: 'ETHNICITY'}]}
                                />
                            </span>
                            <button type="button" className="relationships-default-button" onClick={this.close}>Close</button>
                        </div>
                    </div>
                </ReactModal>
            </span>
        );
    };
}

RelationshipsGraphDialog.propTypes = {
    relationships: PropTypes.array.isRequired
};

export default RelationshipsGraphDialog;


